import React, { useEffect } from "react";
import useStyleInsertForm from "../../styles/adminStyles/useStyleInsertForm";

import { Hidden } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import { Typography } from "@material-ui/core";

import { TextField } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { InputLabel } from "@material-ui/core";
import { Select } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { TextareaAutosize } from "@material-ui/core";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableContainer } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { IconButton } from "@material-ui/core/";

import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import CancelIcon from "@material-ui/icons/Cancel";

import { InputAdornment } from "@material-ui/core/";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import Button from "@material-ui/core/Button";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import Input from "./controls/Input";
import TwoItems from "./controls/TwoItems";

import { useAuth0 } from "@auth0/auth0-react";

import UseForm from "./UseForm";

import { menuTipologia } from "../../data/ValueArray";

const InsertForm = () => {
    const classes = useStyleInsertForm();

    const {
        values,
        //setValues,
        member,
        //setMember,
        tagg,
        //setTagg,
        partner,
        //setPartner,
        media,
        //setMedia,
        responsabile,
        //setResponsabile,
        isActive,
        setIsActive,
        handleInputChange,
        handleArray,
        handleChange,
        handleDel,
        handleSubmit,
        handleResetForm,
    } = UseForm();

    //**************************************************************************************************
    // Devo usare useEffect per poter gestire la presenza in posizione '0' del media 'immagine'
    // in questo modo al variare di 'values' posso capire se values.Media ha 'immagine' in posizione '0'
    //**************************************************************************************************

    useEffect(() => {
        const index = values.Media.findIndex((item) => item.cosa === "immagine");
        console.log("sei " + index);
        if (index === 0) {
            //'Immagine' è al primo posto
            //console.log(values.Media[0].link);
            setIsActive("false");
        } else {
            //console.log("non sei primo");
            setIsActive("true");
        }
        /*return () => {
                cleanup
            }*/
    }, [values]);

    const { logout } = useAuth0();
    console.log(window.location.origin + process.env.PUBLIC_URL + "/Admin");
    return (
        <>
            <Grid container direction="row">
                <Hidden only={["xs", "sm", "md"]}>
                    <Grid item lg={4} className={classes.leftColumn}>
                        <Grid container direction="column">
                            <Grid item>
                                {isActive === "true" ? (
                                    <div className={classes.leftColumnImg}></div>
                                ) : (
                                    <div
                                        style={{
                                            backgroundImage: `url("${values.Media[0].link}")`,
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover",
                                            height: "75vh",
                                        }}
                                    ></div>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Grid item lg={8} className={classes.rightColumn}>
                    <Grid container>
                        <form className={classes.root} onSubmit={handleSubmit}>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel id="Tipologia-label">Tipologia</InputLabel>
                                    <Select
                                        required
                                        labelId="Tipologia-label"
                                        id="Tipologia"
                                        value={values.Tipologia.tipo}
                                        label="Tipologia"
                                        name="tipo"
                                        onChange={handleInputChange("Tipologia")}
                                    >
                                        <MenuItem value="">
                                            <em>...</em>
                                        </MenuItem>
                                        {
                                            /* ho messo in un file esterno l'Array con le voci di menu... */
                                            menuTipologia.map((item) => (
                                                <MenuItem key={item.id} value={item.tipo} id={item.id}>
                                                    {item.tipo}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>

                                <Input
                                    required
                                    variant="outlined"
                                    label="Anno"
                                    value={values.anno_di_avvio}
                                    className={`${classes.itemSpacing} ${classes.textField}`}
                                    onChange={handleInputChange()}
                                    name="anno_di_avvio"
                                />

                                <Input
                                    required
                                    variant="outlined"
                                    label="Titolo"
                                    value={values.titolo}
                                    className={`${classes.itemSpacing} ${classes.textField}`}
                                    onChange={handleInputChange()}
                                    name="titolo"
                                />

                                <Input
                                    required
                                    variant="outlined"
                                    label="acronimo"
                                    value={values.acronimo}
                                    className={`${classes.itemSpacing} ${classes.textField}`}
                                    onChange={handleInputChange()}
                                    name="acronimo"
                                />

                                <Input
                                    variant="outlined"
                                    label="Sito WEB"
                                    value={values.web}
                                    className={`${classes.itemSpacing} ${classes.textField}`}
                                    onChange={handleInputChange()}
                                    name="web"
                                />

                                <Input
                                    variant="outlined"
                                    label="Ruolo UNIFI"
                                    value={values.ruolo_Unifi}
                                    className={`${classes.itemSpacing} ${classes.textField}`}
                                    onChange={handleInputChange()}
                                    name="ruolo_Unifi"
                                />
                            </Grid>

                            <Divider className={classes.hrOriz} />

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        display="block"
                                        className={classes.titolo}
                                    >
                                        Responsabile
                                    </Typography>
                                    <Grid item xs={12}>
                                        <TwoItems
                                            n_input="nome"
                                            input_nome={responsabile.nome}
                                            l_input="link"
                                            label="Responsabile ricerca"
                                            input_link={responsabile.link}
                                            onChange={(ev) => handleChange("Responsabile", ev)}
                                            className={classes.tablePartner}
                                            onClick={() => handleArray("Responsabile")}
                                            values={values.Responsabile}
                                            handleDelete={(index) =>
                                                handleDel(values.Responsabile, index)
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Divider className={classes.hrOriz} />

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        display="block"
                                        className={classes.titolo}
                                    >
                                        Abstract
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextareaAutosize
                                        className={`${classes.itemSpacing} ${classes.textArea}`}
                                        rowsMin={8}
                                        rowsMax={8}
                                        aria-label="maximum height"
                                        placeholder="Abstract ITA"
                                        name="ita"
                                        value={values.Abstract.ita}
                                        onChange={handleInputChange("Abstract")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextareaAutosize
                                        className={`${classes.itemSpacing} ${classes.textArea}`}
                                        rowsMin={8}
                                        rowsMax={8}
                                        aria-label="maximum height"
                                        placeholder="Abstract ENG"
                                        name="eng"
                                        value={values.Abstract.eng}
                                        onChange={handleInputChange("Abstract")}
                                    />
                                </Grid>
                            </Grid>

                            <Divider className={classes.hrOriz} />

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Box className={classes.boxBackground}>
                                        <Typography
                                            variant="h4"
                                            gutterBottom
                                            className={classes.titolo}
                                        >
                                            Parole Chiave
                                        </Typography>

                                        <Input
                                            //required
                                            name="New_tag"
                                            value={tagg}
                                            label="Inserisci una Parola Chiave"
                                            //onChange = {handleTaggChange}
                                            onChange={(ev) => handleChange("Tags", ev)}
                                            className={classes.inputItem}
                                        />
                                        <Fab
                                            color="primary"
                                            aria-label="add"
                                            //onClick = {handleTags}
                                            size="medium"
                                            onClick={() => handleArray("Tags")} //usa la "arrow function" altrimenti non funziona....
                                        >
                                            <AddIcon />
                                        </Fab>
                                        <TableContainer className={classes.tableTags}>
                                            <Table size="small" aria-label="Parole Chiave">
                                                <TableBody>
                                                    {values.Parole_Chiave.map((tag, index) => (
                                                        <>
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    <TextField
                                                                        //value = {values.Parole_Chiave[index]}
                                                                        value={tag}
                                                                        name="Parole_Chiave"
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <VpnKeyIcon
                                                                                        style={{ fill: "green" }}
                                                                                    />
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                        className={classes.tableTags}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <IconButton
                                                                        aria-label="delete"
                                                                        onClick={() =>
                                                                            handleDel(values.Parole_Chiave, index)
                                                                        }
                                                                    >
                                                                        <CancelIcon style={{ fill: "red" }} />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        className={classes.titolo}
                                    >
                                        Partner
                                    </Typography>

                                    <TwoItems
                                        n_input="nome"
                                        input_nome={partner.nome}
                                        l_input="link"
                                        label="Inserisci nome Partner"
                                        input_link={partner.link}
                                        onChange={(ev) => handleChange("Partners", ev)}
                                        className={classes.tablePartner}
                                        onClick={() => handleArray("Partners")}
                                        values={values.Partner}
                                        handleDelete={(index) => handleDel(values.Partner, index)}
                                    />
                                </Grid>
                            </Grid>

                            <Divider className={classes.hrOriz} />

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        className={classes.titolo}
                                    >
                                        UNIFI Team
                                    </Typography>

                                    <TwoItems
                                        n_input="nome"
                                        input_nome={member.nome}
                                        l_input="link"
                                        label="Team member"
                                        input_link={member.link}
                                        onChange={(ev) => handleChange("Members", ev)}
                                        className={classes.tablePartner}
                                        onClick={() => handleArray("Members")}
                                        values={values.UNIFI_Team}
                                        handleDelete={(index) =>
                                            handleDel(values.UNIFI_Team, index)
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Box className={classes.boxBackground}>
                                        <Typography
                                            variant="h4"
                                            gutterBottom
                                            className={classes.titolo}
                                        >
                                            Media
                                        </Typography>

                                        <TwoItems
                                            n_input="cosa"
                                            input_nome={media.cosa}
                                            l_input="link"
                                            label="Media type"
                                            input_link={media.link}
                                            onChange={(ev) => handleChange("Media", ev)}
                                            className={classes.tablePartner}
                                            onClick={() => handleArray("Media")}
                                            values={values.Media}
                                            handleDelete={(index) => handleDel(values.Media, index)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} style={{ textAlign: "center" }}>
                                    <Button
                                        variant="contained"
                                        className={classes.spacing}
                                        color="primary"
                                        type="submit"
                                    >
                                        Registra...
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.spacing}
                                        onClick={handleResetForm}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.spacing}
                                        color="primary"
                                        onClick={() => logout({ returnTo: window.location.origin + process.env.PUBLIC_URL + "/Admin" })}
                                        endIcon={<ExitToAppIcon />}
                                    >
                                        LOGOUT!
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default InsertForm;
